import { useLayout } from "../layout/core";
import { ThemeModeComponent } from "../assets/ts/layout";
import { themes } from "@/core/datas/logo-datas";

export const renderLogo = (): string | undefined => {
  const url = window.location.hostname;
  const theme = themes.find(x => x.key == url);
  const value = '/custom/' + theme?.logo;
  return value;
}

export const renderInnerDefaultLogo = (): string | undefined => {
  const url = window.location.hostname;
  const theme = themes.find(x => x.key == url);
  const value = '/custom/' + theme?.innerLogo;
  return value;
}
export const renderInnerStickyLogo = (): string | undefined => {
  const url = window.location.hostname;
  const theme = themes.find(x => x.key == url);
  const value = '/custom/' + theme?.logo;
  return value;
}
export const renderLogoSize = (): string | undefined => {
  const url = window.location.hostname;
  const theme = themes.find(x => x.key == url);
  const value = theme?.logoSize;
  return value;
}
export const renderInnerLogoSize = (): string | undefined => {
  const url = window.location.hostname;
  const theme = themes.find(x => x.key == url);
  const value = theme?.innerLogoSize;
  return value;
}
export const renderLoginBg = (): string | undefined => {
  const url = window.location.hostname;
  const theme = themes.find(x => x.key == url);
  const value = '/custom/' + theme?.loginBg;
  return value;
}
export const renderLoginShape = (): string | undefined => {
  const url = window.location.hostname;
  const theme = themes.find(x => x.key == url);
  const value = '/custom/' + theme?.loginShape;
  return value;
}
export const toAbsoluteUrl = (pathname: string) =>
  import.meta.env.BASE_URL + pathname;

export const useIllustrationsPath = (illustrationName: string): string => {
  const { config } = useLayout();

  const extension = illustrationName.substring(
    illustrationName.lastIndexOf("."),
    illustrationName.length
  );
  const illustration =
    ThemeModeComponent.getMode() === "dark"
      ? `${illustrationName.substring(
        0,
        illustrationName.lastIndexOf(".")
      )}-dark`
      : illustrationName.substring(0, illustrationName.lastIndexOf("."));
  return toAbsoluteUrl(
    `media/illustrations/${config.illustrations?.set}/${illustration}${extension}`
  );
};